module.exports = __webpack_public_path__ + "img/pic_do03@2x.c893c273.png";